import AssignmentTurnedIn from '@mui/icons-material/AssignmentTurnedIn';
import CheckCircle from '@mui/icons-material/CheckCircle';
import { Illustration } from './Illustration';

export const EmptyStateIllustration = () => (
  <Illustration
    PrimaryIcon={AssignmentTurnedIn}
    SecondaryIcon={CheckCircle}
    accentPalette="primary"
    lineWidths={['75%', '50%', '66%']}
  />
);
